(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .directive('xxBrand', xxBrand);

    var DOMAIN_REGEX = /\.([^\.]+)\.[^\.]+$/,
        DEFAULT_SITE = 'default';

    xxBrand.$inject = ['$location', 'siteType'];
    function xxBrand($location, siteType) {
        return {
            restrict: 'E',
            template: '<link ng-href="css/{{filename}}" rel="stylesheet" />',
            link: link,
            scope: {},
            replace: true
        }

        function link(scope, element, attr, transclude) {
            var host = $location.host(),
                port = $location.port(),
                siteId = app.Branding.siteId,
                isDebug = host.toLowerCase() === "localhost" && port != 443 && port != 80,
                domain, site, filename, rel;

            domain = (DOMAIN_REGEX.exec(host) || [])[1];
            site = siteType[siteId] || siteType[domain] || siteType[DEFAULT_SITE];
            if (angular.isNumber(site))
                site = siteType[site]

            scope.filename = site + (isDebug ? '.css' : '.min.css');
        }
    }
})();
